module.exports = __webpack_public_path__ + "media/images/subject_img/JOURNALISM-109c9139c5859672015efbfc3b4556f6.jpg";